import {ajax} from '../../utils/ajax';

export function sendMobileToServer(number){
    return ajax(null, '/Account/login', 'POST', true, {mobilenumber: number})
}
export function verifyMobileNo(number, code){
    return ajax(null, '/Account/verifyMobile', 'POST', true, {mobilenumber: number, verifCode: code})
}